var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeckoterminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000176042682442889539860000010451686635505538238_);}\n\t.st2{fill:url(#SVGID_00000076603531774506168890000003812489970509166744_);}\n\t.st3{fill:url(#SVGID_00000011005632303961264570000007049580027565548959_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:url(#SVGID_00000125562899394939770440000008689923499076957330_);}\n\t.st6{fill:#1E1E1E;}\n\t.st7{fill:none;}\n\t.st8{fill:url(#SVGID_00000132081855495055972210000000378270796029004434_);}\n\t.st9{fill:url(#SVGID_00000052069566387543672820000014483649099582574482_);}\n\t.st10{fill:url(#SVGID_00000171702535718964045050000002328827255753744282_);}\n\t.st11{fill:url(#SVGID_00000118369662903437151140000005768695958068556210_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.9384,
    y1: 1211.8888,
    x2: 1254.7654,
    y2: 357.7175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1128.6,435l-65.8-65.8c-44.8,36.5-122.3,67.2-171.1,83.1c-2.2,0.7-4.3,1.6-6.5,2.4 c-12.9,12.7-25.5,26.1-37.3,40.2l96.1,96.1l179.7,179.7l4.9-4.9C1219.9,674.4,1219.9,526.3,1128.6,435z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159439605239923174140000011762872132343976110_",
    gradientUnits: "userSpaceOnUse",
    x1: 566.9784,
    y1: 1040.2743,
    x2: 1278.4192,
    y2: 344.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159439605239923174140000011762872132343976110_)"
    },
    d: "M1128.6,435l-65.8-65.8 c-44.8,36.5-122.3,67.2-171.1,83.1c-2.2,0.7-4.3,1.6-6.5,2.4c-12.9,12.7-25.5,26.1-37.3,40.2l96.1,96.1l179.7,179.7l4.9-4.9 C1219.9,674.4,1219.9,526.3,1128.6,435z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126302283668234263850000009517931987837776005_",
    gradientUnits: "userSpaceOnUse",
    x1: -24.967,
    y1: 778.9039,
    x2: 813.86,
    y2: -75.2674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126302283668234263850000009517931987837776005_)"
    },
    d: "M255.1,590.9l187.1-187.1 c4.9-13.4,10.2-26.9,16.1-40.1c56.4-126.4,183-169.3,302.1-171.4c15.7-27.8,45.4-46.3,78.8-46.7l-74.3-74.3 C673.6-20,525.5-20,434.2,71.3l-4.9,4.9L75.4,430.1l179.7,179.7C249.9,604.6,249.9,596.1,255.1,590.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017478737622493935020000017021814541745792699_",
    gradientUnits: "userSpaceOnUse",
    x1: -394.6889,
    y1: 1001.1366,
    x2: 1076.155,
    y2: -272.5289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017478737622493935020000017021814541745792699_)"
    },
    d: "M255.1,590.9l187.1-187.1 c4.9-13.4,10.2-26.9,16.1-40.1c56.4-126.4,183-169.3,302.1-171.4c15.7-27.8,45.4-46.3,78.8-46.7l-74.3-74.3 C673.6-20,525.5-20,434.2,71.3l-4.9,4.9L75.4,430.1l179.7,179.7C249.9,604.6,249.9,596.1,255.1,590.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M901.6,208L901.6,208C901.5,207.9,901.5,207.9,901.6,208C901.5,208,901.6,208,901.6,208z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065053756903845841440000015695574779816946336_",
    gradientUnits: "userSpaceOnUse",
    x1: 1065.2753,
    y1: 128.9613,
    x2: 180.6372,
    y2: 1024.2576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065053756903845841440000015695574779816946336_)"
    },
    d: "M944,590.9c5.2,5.2,5.2,13.7,0,18.9 L778.5,775.3L737.8,816L627.6,926.2L609,944.8c-5.2,5.2-13.7,5.2-18.9,0c0,0,0,0,0,0L422.6,777.3L312.5,667.2l-57.4-57.4 L75.4,430.1l-4.9,4.9c-91.3,91.3-91.3,239.4,0,330.7l41.6,41.6l312.5,312.5l9.6,9.6c91.3,91.3,239.4,91.3,330.7,0l4.9-4.9 l353.9-353.9L944,590.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M901.5,208C901.5,207.9,901.5,207.9,901.5,208L901.5,208c-6.5-14.4-18-26.4-33.3-33.4l0,0 c-0.5-0.2-0.9-0.5-1.4-0.7c-2-0.9-4.1-1.6-6.1-2.3c1.2,7.2,0.4,14.9-2.7,22.1c-0.8,1.8-1.8,3.5-2.9,5.2 c-10.3,16.7-31.4,23.9-49.9,16c-8.8-3.7-15.5-10.3-19.7-18.1c-2.7,3.8-5.1,8-7,12.5c-14.6,34.2,1.2,73.7,35.4,88.3 c34.2,14.6,73.7-1.2,88.3-35.4C909.9,244.1,909.1,224.6,901.5,208z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M813.9,297.6c34.2,14.6,73.7-1.2,88.3-35.4c7.7-18.1,6.9-37.6-0.7-54.3c0,0,0,0,0.1,0l-0.1-0.1 c-6.5-14.3-18-26.3-33.3-33.3c-0.5-0.2-0.9-0.5-1.4-0.7c-2-0.9-4.1-1.6-6.1-2.3c1.2,7.2,0.4,14.9-2.7,22.1 c-0.8,1.8-1.8,3.5-2.9,5.2c-10.3,16.7-31.4,23.9-49.9,16c-8.8-3.7-15.5-10.3-19.7-18.1c-2.7,3.8-5.1,8-7,12.5 C763.9,243.5,779.7,283,813.9,297.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099655562343824716890000000135746748955475361_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.4637,
    y1: 548.3904,
    x2: 442.9577,
    y2: 548.3904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099655562343824716890000000135746748955475361_)"
    },
    d: "M442.9,401.9c-0.2,0.6-0.6,1.2-0.7,1.9 c-34.7,183.4-51.8,209.2-129.8,263.4l27.7,27.7c18.1-17.9,44.1-48.7,68.7-96.4C439.1,540.1,443.3,451.9,442.9,401.9z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M901.6,208L901.6,208c-6.6-14.4-18.1-26.4-33.4-33.4c-0.5-0.2-0.9-0.5-1.4-0.7c-2-0.9-4.1-1.6-6.1-2.3 c1.2,7.2,0.4,14.9-2.7,22.1c-0.8,1.8-1.8,3.5-2.9,5.2c-10.3,16.7-31.4,23.9-49.9,16c-8.8-3.7-15.5-10.3-19.7-18.1 c-2.7,3.8-5.1,8-7,12.5c-14.6,34.2,1.2,73.7,35.4,88.3c34.2,14.6,73.7-1.2,88.3-35.4C909.9,244.1,909.1,224.6,901.6,208 C901.6,208,901.6,208,901.6,208z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M836.1,483.3c0.5-0.4,1-0.8,1.5-1.2c-0.5,0.4-0.9,0.7-1.4,1.1c-17.4,14.1-33.8,31.9-48,53.3 C802.5,515.1,818.7,497.3,836.1,483.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056428700200994621280000004610028807205818752_",
    gradientUnits: "userSpaceOnUse",
    x1: -1474.4463,
    y1: 7731.2188,
    x2: -7.2404,
    y2: 3138.2261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056428700200994621280000004610028807205818752_)"
    },
    d: "M837.6,482.1c-0.5,0.4-1.1,0.9-1.5,1.2 c-17.4,14-33.7,31.8-47.9,53.1c-42.8,63.9-67.4,159.4-50.4,279.6l-0.1,0.1c0,0,0,0,0,0.1l65.2-64c-2.8-9.5-5.4-19.4-7.8-29.7 c-22.5-95.2-5.8-157.9,52.7-227.4c7.3-8.7,24.2-26,39.1-40.9c-0.6,0.2-1.1,0.4-1.7,0.6C868.9,460.8,852.9,470,837.6,482.1z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M788.2,536.4c-42.8,63.9-67.5,159.4-50.5,279.7l0.1-0.1C720.8,695.8,745.4,600.3,788.2,536.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011016003095055086100000007163039138390059656_",
    gradientUnits: "userSpaceOnUse",
    x1: -1494.7433,
    y1: 7724.7349,
    x2: -27.5374,
    y2: 3131.7424
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011016003095055086100000007163039138390059656_)"
    },
    d: "M788.2,536.4 c-42.8,63.9-67.5,159.4-50.5,279.7l0.1-0.1C720.8,695.8,745.4,600.3,788.2,536.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116226615795717050840000009377207181981294724_",
    gradientUnits: "userSpaceOnUse",
    x1: 804.3041,
    y1: 257.0724,
    x2: 1117.0403,
    y2: 257.0724
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5D47FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5903,
    style: {
      stopColor: "#846DFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A36CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116226615795717050840000009377207181981294724_)"
    },
    d: "M1108.1,278.6 c-38.3-54-154.4-79-154.4-79s-15.8-43.8-56.7-57.5c-37-12.3-92.7,9.8-92.7,9.8l0.8,0.7c10.6-4.4,22.1-6.9,34.1-7.1 c2.9,0,5.7,0,8.6,0.3c40,3.3,71.9,31.8,81.3,68.6c195,48.3,192.7,106.6,133.6,154.7c-2.3,1.9-4.8,3.8-7.3,5.6l1,0.9 C1056.5,375.7,1144.8,330.4,1108.1,278.6z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M929.2,214.5c-9.5-36.8-41.3-65.3-81.3-68.6c-2.9-0.2-5.8-0.3-8.6-0.3c-12,0.1-23.5,2.7-34.1,7.1 c-18.8,7.9-34.6,21.8-44.6,39.6c-119.2,2.1-245.7,44.9-302.1,171.4c-5.6,12.6-10.6,25.4-15.4,38.2c0.4,50-3.9,138.3-34,196.6 c-24.6,47.7-50.6,78.5-68.7,96.4l82.4,82.4l167.5,167.5c0,0,0,0,0,0c5.2,5.2,13.7,5.2,18.9,0l18.6-18.6l110.1-110.1 c-17-120.3,7.7-215.8,50.5-279.7c14.3-21.4,30.6-39.2,48-53.3c0.5-0.4,0.9-0.7,1.4-1.1c15.2-12,31.3-21.3,47.6-27.4 c0.6-0.2,1.1-0.4,1.7-0.6c1.6-0.6,3.2-1.2,4.8-1.8c46.2-15.1,118.2-43.5,163.8-77.5c2.5-1.9,4.9-3.7,7.3-5.6 C1121.9,321,1124.2,262.7,929.2,214.5z M902.2,262.2c-14.6,34.2-54.2,50-88.3,35.4c-34.2-14.6-50-54.2-35.4-88.3 c1.9-4.5,4.3-8.7,7-12.5c4.2,7.8,10.9,14.3,19.7,18.1c18.6,7.9,39.7,0.7,49.9-16c0.2-0.4,0.4-0.8,0.7-1.2 c0.8-1.3,1.6-2.5,2.2-3.9c3.1-7.2,3.9-14.9,2.7-22.1c2.1,0.7,4.1,1.4,6.1,2.3c0.5,0.2,0.9,0.5,1.4,0.7c15.3,7,26.8,19,33.3,33.3 l0.1,0.1c0,0,0,0-0.1,0c4.9,10.9,6.9,23,5.6,35.2C906.4,249.6,904.9,256,902.2,262.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeckoterminal);
export default __webpack_public_path__ + "static/media/Geckoterminal.9048c8f45748a66cf5a960102c1e508f.svg";
export { ForwardRef as ReactComponent };